export enum NotificationUnitOfTime {
  MIN = 'MIN',
  H = 'H',
  D = 'D',
}
